module.exports = __webpack_public_path__ + "static/media/amenity-popcorn.4aeb8276.svg";